
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-an-ambassador",
      function () {
        return require("private-next-pages/become-an-ambassador.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-an-ambassador"])
      });
    }
  